<template>
	<div class="wrapper">
		<hr>
		<div class="content row justify-content-center upper-footer">
			<div class="col-lg-3">
				<div class="footerTitle">
					<p>Informationskompetenz</p>
				</div>
				<p class="iktext">
					Informationskompetenz – Menschenrecht und Schlüsselkompetenz des 21.
					Jahrhunderts.
				</p>
			</div>
			<div class="col-lg-3">
				<div class="footerTitle">
					<p>Hinweise</p>
				</div>
				<p>
					<a href="https://www.fhnw.ch/de/impressum/datenschutz" target="_blank"
						>Datenschutz</a
					>
					<br>
					<router-link :to="{ name: 'Impressum' }">Impressum</router-link>
				</p>
			</div>
			<div class="col-lg-3">
				<div class="footerTitle">
					<p>Inhalte</p>
				</div>
				<p><a class="link" href="#" @click="download">Verwendete Quellen</a></p>
				<p v-if="buildDate" class="build-version">Build: {{ buildDate }}</p>
			</div>
		</div>

		<hr>
		<div class="lowerFooter">
			<img src="/assets/FHNW_HTU_DE.svg" alt="FHNW HTU Logo" class="footer-logo">
			<div class="copyright">
				<a href="https://pik.igs.htu.fhnw.ch/" target="_blank"
					>Plattform Informationskompetenz</a
				>
				© 2022 by
				<a
					href="https://www.fhnw.ch/de/die-fhnw/hochschulen/ht/institute/institut-fuer-geistes-und-sozialwissenschaften"
					target="_blank"
					>Institut für Geistes- und Sozialwissenschaften (IGS) FHNW</a
				>
				is licensed under
				<a
					href="https://creativecommons.org/licenses/by-sa/4.0/"
					style="padding-right: 0.1em"
					target="_blank"
					>CC BY-SA 4.0</a
				>
				{{ ' ' }}
				<img src="/assets/cc.svg" alt="CC" class="cc-icon">
				<img src="/assets/by.svg" alt="BY" class="cc-icon">
				<img src="/assets/sa.svg" alt="SA" class="cc-icon">
			</div>
			<img src="/assets/FHNW_HSI_DE.svg" alt="FHNW HSI Logo" class="footer-logo">
		</div>
	</div>
</template>

<script>
export default {
	name: 'picFooter',

	data() {
		return {
			Test: 'Hello World',
			year: new Date().getFullYear(),
			publicPath: window.location.origin,
			buildDate: null,
		};
	},
	created() {
		this.loadBuildInfo();
	},
	methods: {
		async loadBuildInfo() {
			try {
				const response = await fetch(`${this.publicPath}/build-info.json`);
				if (response.ok) {
					const data = await response.json();
					this.buildDate = data.buildDate;
				}
			} catch (e) {
				console.error('Failed to load build info');
			}
		},
		download(e) {
			e.stopPropagation();
			e.preventDefault();
			window.open(
				`${this.publicPath}/downloads/Verwendete_Quellen_Plattform_Informationskompetenz_(Stand_April_23).pdf`,
				'_blank',
			);
			return false;
		},
	},
};
</script>

<style scoped>
.overlay {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.7);
	transition: opacity 500ms;
	visibility: hidden;
	opacity: 0;
}

.overlay:target {
	visibility: visible;
	opacity: 1;
}

.popup {
	margin: 500px auto;
	padding: 20px;
	background: #fff;
	border-radius: 5px;
	width: 30%;
	position: relative;
	transition: all 5s ease-in-out;
}

.popup .close {
	position: absolute;
	top: 20px;
	right: 30px;
	transition: all 200ms;
	font-size: 30px;
	font-weight: bold;
	text-decoration: none;
	color: #333;
}

.popup .close:hover {
	color: #06d85f;
}

.popup .content {
	max-height: 30%;
	overflow: auto;
}

.wrapper {
	/* height: 346px; */
	/* width: 100%; */
	margin-top: 2.5rem;
}

.content {
	min-height: 120px;
	/* Reduced from 264px to make the gap smaller */
	margin-right: 0;
}

.lowerFooter {
	width: 100%;
	/* height: 80px; Let content define height or adjust */
	background-color: #eef6ff;
	/* text-align: right; Removed */
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 1em 2vw;
	/* Added padding */
	box-sizing: border-box;
	min-height: 100px;
}

hr {
	margin: 0;
}

.copyright {
	/* margin-right: 5vw; Removed */
	/* top: 50%; Removed */
	/* position: relative; Removed */
	/* transform: translateY(-50%); Removed */
	/* display: inline-flex; Keep internal alignment styles if needed, or simplify */
	/* align-items: center; */
	/* flex-wrap: wrap; */
	/* justify-content: center; */
	text-align: center;
	/* Center the text/icons within this block */
	flex-grow: 1;
	/* Allow block to take available space */
	margin: 0 1em;
	/* Add horizontal margin */
	display: inline-block;
	/* Or simply let flexbox handle it */
}

.footer-logo {
	height: 35px;

	/* Adjust size as needed */
	width: auto;
	vertical-align: middle;
	/* May not be needed with flex */
	flex-shrink: 0;
	/* Prevent shrinking */
}
.build-version {
	font-size: 0.75rem;
	color: #6c757d;
	white-space: nowrap;
}

.cc-icon {
	padding-right: 0.1em;
	height: 1em;
	width: auto;
	vertical-align: middle;
}

.iktext {
	padding-right: 5rem;
}

.footerTitle {
	padding-top: 20px;
	/* Reduced from 35px to make the gap smaller */
	font-weight: 600;
}

.upper-footer {
	min-height: 150px;
}
</style>
